import { Button, IconButton } from '@mui/material'
import WindowDialog from 'components/dialog/WindowDialog'
import React, { useState } from 'react'
import { Delete as DeleteIcon } from '@mui/icons-material';
import PainelAgendaReuniao from '../PainelAgendaReuniao'

export default function DialogAgendar({
    getReuniao,
    getReunioes,
    reunioes,
    updateReuniao,
    setParticipante2,
    removeParticipante2,
    temAgendamentoNoHorarioGlobal,
    showWarning,
    mesa,
    participanteRow, // fornecedor ou ancora da linha da tabela
    participanteTab, // fornecedor ou ancora da aba
}) {
    const [open, setOpen] = useState(false)
    let reuniao = getReuniao(participanteTab, participanteRow.uid)
    const reunioesP2 = getReunioes(participanteRow.uid)

    return <>
        {reuniao ?
            <IconButton onClick={() => removeParticipante2(reuniao)}><DeleteIcon /></IconButton>
            :
            <Button onClick={() => setOpen(true)}>Agendar</Button>
        }
        {open &&
            <WindowDialog
                title={"Agendar"}
                onClose={() => {
                    setOpen(false)
                }}
                open={open}
            >
                {(dialogProps) => (
                    <PainelAgendaReuniao
                        rodada={reunioes[0].rodada}
                        reunioes={reunioes.concat(reunioesP2)}
                        mesa={mesa}
                        onClick={(horario, mesa) => {

                            if (!temAgendamentoNoHorarioGlobal(participanteRow.uid, horario.horario)) {
                                let reuniaoMarcadaIndex = reunioes.map(r => r.horario.horario).indexOf(horario.horario)
                                let reuniaousar = reunioes[reuniaoMarcadaIndex]
                                reuniaousar.mesa = mesa
                                console.log('reuniaousar', reuniaousar)
                                setParticipante2(reuniaousar, participanteRow)
                                setOpen(false)
                            } else {
                                showWarning("Este fornecedor já possui agendamento para este horário")
                            }
                        }}
                    />

                )}
            </WindowDialog>
        }

    </>
}